export default {
	"Verification.one": "壹",
	"Verification.two": "貳",
	"Verification.three": "三",
	"Verification.shop": "肆",
	"Verification.five": "伍",
	"Verification.land": "陸",
	"Verification.Seven": "柒",
	"Verification.splitOpen": "捌",
	"Verification.Nine": "玖",
	"Verification.ParentVerification": "家長驗證",
	"Verification.ClickInOrder": "請按順序依次點擊："
}